import { render, staticRenderFns } from "./CreateCommunity.vue?vue&type=template&id=728f61e7&scoped=true"
import script from "./CreateCommunity.vue?vue&type=script&lang=js"
export * from "./CreateCommunity.vue?vue&type=script&lang=js"
import style0 from "./CreateCommunity.vue?vue&type=style&index=0&id=728f61e7&prod&scoped=true&lang=css"
import style1 from "./CreateCommunity.vue?vue&type=style&index=1&id=728f61e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728f61e7",
  null
  
)

export default component.exports